<!-- eslint-disable max-len -->
<template>
  <CardBase class="search-card" injected-class-names="''" class-name="''">
    <h2 :class="customClass">
      {{ label }}
    </h2>
    <h2 v-if="error !== ''" class="text-red-600 text-center font-bold mt-5">
      {{ error }}
    </h2>
    <div class="mt-3">
      <button
          class="
                mb-3
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_action btn-transparent
                w-full
              "
          @click="resetDateToToday()"
      >
        <span>{{ $t("pages.offers.buttons.resetdate") }}</span>
      </button>

      <div class="search-card__datepicker input-group ds-cunstome-picker">
        <span class="input-group-addon col-auto">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.25 0C1.46403 0 0 1.46403 0 3.25V14.75C0 16.536 1.46403 18 3.25 18H14.75C16.536 18 18 16.536 18 14.75V3.25C18 1.46403 16.536 0 14.75 0H3.25ZM3.25 1.5H14.75C15.725 1.5 16.5 2.27497 16.5 3.25V4H1.5V3.25C1.5 2.27497 2.27497 1.5 3.25 1.5ZM1.5 5.5H16.5V14.75C16.5 15.725 15.725 16.5 14.75 16.5H3.25C2.27497 16.5 1.5 15.725 1.5 14.75V5.5ZM4.75 7.5C4.41848 7.5 4.10054 7.6317 3.86612 7.86612C3.6317 8.10054 3.5 8.41848 3.5 8.75C3.5 9.08152 3.6317 9.39946 3.86612 9.63388C4.10054 9.8683 4.41848 10 4.75 10C5.08152 10 5.39946 9.8683 5.63388 9.63388C5.8683 9.39946 6 9.08152 6 8.75C6 8.41848 5.8683 8.10054 5.63388 7.86612C5.39946 7.6317 5.08152 7.5 4.75 7.5ZM9 7.5C8.66848 7.5 8.35054 7.6317 8.11612 7.86612C7.8817 8.10054 7.75 8.41848 7.75 8.75C7.75 9.08152 7.8817 9.39946 8.11612 9.63388C8.35054 9.8683 8.66848 10 9 10C9.33152 10 9.64946 9.8683 9.88388 9.63388C10.1183 9.39946 10.25 9.08152 10.25 8.75C10.25 8.41848 10.1183 8.10054 9.88388 7.86612C9.64946 7.6317 9.33152 7.5 9 7.5ZM13.25 7.5C12.9185 7.5 12.6005 7.6317 12.3661 7.86612C12.1317 8.10054 12 8.41848 12 8.75C12 9.08152 12.1317 9.39946 12.3661 9.63388C12.6005 9.8683 12.9185 10 13.25 10C13.5815 10 13.8995 9.8683 14.1339 9.63388C14.3683 9.39946 14.5 9.08152 14.5 8.75C14.5 8.41848 14.3683 8.10054 14.1339 7.86612C13.8995 7.6317 13.5815 7.5 13.25 7.5ZM4.75 12C4.41848 12 4.10054 12.1317 3.86612 12.3661C3.6317 12.6005 3.5 12.9185 3.5 13.25C3.5 13.5815 3.6317 13.8995 3.86612 14.1339C4.10054 14.3683 4.41848 14.5 4.75 14.5C5.08152 14.5 5.39946 14.3683 5.63388 14.1339C5.8683 13.8995 6 13.5815 6 13.25C6 12.9185 5.8683 12.6005 5.63388 12.3661C5.39946 12.1317 5.08152 12 4.75 12ZM9 12C8.66848 12 8.35054 12.1317 8.11612 12.3661C7.8817 12.6005 7.75 12.9185 7.75 13.25C7.75 13.5815 7.8817 13.8995 8.11612 14.1339C8.35054 14.3683 8.66848 14.5 9 14.5C9.33152 14.5 9.64946 14.3683 9.88388 14.1339C10.1183 13.8995 10.25 13.5815 10.25 13.25C10.25 12.9185 10.1183 12.6005 9.88388 12.3661C9.64946 12.1317 9.33152 12 9 12Z"
              fill="#333333"
            />
          </svg>
        </span>
        <datepicker
          v-model="date"
          input-class="search-card__datepicker-input pkss-text secondary placeholder-gray-500 form-control card__datepicker"
          :placeholder="$t('pages.offers.input.placeholder')"
          :language="lang"
          format="dd.MM.yyyy"
          :highlighted="highlighted"
          :disabled-dates="{ to: yesterday }"
          @selected="selectedDate"
        />
      </div>
    </div>
  </CardBase>
</template>

<script>
import CardBase from "@/components/shared/CardBase";
import Datepicker from "vuejs-datepicker";
import { de, pl, en } from "vuejs-datepicker/dist/locale";

export default {
  name: "SearchCard",
  components: { CardBase, Datepicker },
  props: {
    label: {
      type: String,
      default: function () {
        this.$t("pages.offers.input.label");
      },
    },
    customClass: {
      type: String,
      default: function () {
        return "font-bold page_title";
      },
    },
  },
  data() {
    return {
      showPicker: false,
      date: null,
      error: "",
      highlighted: {
        dates: [
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ),
        ],
        includeDisabled: true,
      },
    };
  },
  computed: {
    yesterday() {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return yesterday;
    },
    lang() {
      if (this.$i18n.locale === "de") {
        return de;
      } else if (this.$i18n.locale === "pl") {
        return pl;
      }

      return en;
    },
  },
  mounted() {
    this.date = this.user?.availability_date;
    this.$emit("date", this.date);
  },
  methods: {

    resetDateToToday() {
      this.date = new Date();
      this.$emit("date", this.date.toISOString().slice(0, 10));
      if (this.$route.name === "offerSearch") {
        this.$store.commit("user/setProfile", {
          ...this.user,
          availability_date: this.date.toISOString().slice(0, 10),
        });

        this.$store.commit("offer/setFilters", {
          availability_date: this.date.toISOString().slice(0, 10),
        });

        this.$store.dispatch("offer/saveFilter");
      }
    },

    selectedDate(date) {
      this.$emit("date", date.toISOString().slice(0, 10));
      if (this.$route.name === "offerSearch") {
        this.$store.commit("user/setProfile", {
          ...this.user,
          availability_date: date.toISOString().slice(0, 10),
        });

        this.$store.commit("offer/setFilters", {
          availability_date: date.toISOString().slice(0, 10),
        });

        this.$store.dispatch("offer/saveFilter");
      }
    },
  },
};
</script>

<style scoped>
.page_title {
  font-size: 16px;
}

.input-group {
  width: 100%;
  border-color: #c6c6d1;
  border-radius: 4px;
  padding: 0;
  height: 46px;
  align-items: center;
  border-width: 1px;
}
.search-card__datepicker-icon {
  color: #cbcdda;
  height: 1.2rem;
  margin-left: 10px;
}

.input-group .input-group-addon {
  height: 100%;
  padding: 6px 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 12%;
  margin-right: 1%;
}

.input-group .input-group-addon img {
  width: 17px;
}
.input-group .input-group-addon img {
  width: 17px;
}
.input-group .input-group-addon svg {
  width: 17px;
  height: 17px;
}

.input-group .form-control {
  width: 100%;
  height: 100%;
  outline: none !important;
  box-shadow: none !important;
  font-size: 16px;
  font-weight: 500;
  color: darkgrey;
  color: #000000;
  font-size: 14px;
  font-weight: 600;
}
.input-group .vdp-datepicker {
  position: relative;
  text-align: left;
  width: 87%;
  padding-right: 10px;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #676666;
}
.vdp-datepicker * {
  box-sizing: border-box;
  height: 100%;
}
.form-control {
  width: 100%;
  font-size: 13px;
  height: 100%;
}
.search-card__datepicker-input {
  font-weight: bold;
  color: #676666;
  width: 100%;
}

.input-group .vdp-datepicker * {
  height: 100%;
}

/*--------------------- scrollssearch_block --------------------- */
.scrollssearch_block {
  padding: 4px 0;
}
.scrollssearch_block .search_form_block {
  width: 100%;
}
.scrollssearch_block .search_form_block h2 {
  display: none;
}
.scrollssearch_block .search_form_block .mt-3 {
  margin: 0 !important;
}
.scrollssearch_block .search_form_block .input-group {
  width: 100%;
}
.scrollssearch_block .search_form_block .search-card {
  width: 83%;
  margin-right: 2%;
}
.scrollssearch_block .search_form_block .filter_action_block {
  width: 15%;
  margin-left: 0;
}
.scrollssearch_block .search_form_block .filter_action_block .btn_apply {
  padding: 4px;
}
.scrollssearch_block .search_form_block .filter_action_block .btn_apply svg {
  margin: 0;
  width: 26px;
  height: 26px;
  fill: rgb(255, 255, 255);
}
/*--------------------- scrollssearch_block --------------------- */

/* --------------------- Date Picker css --------------*/

.ds-cunstome-picker {
  position: relative;
}

.ds-cunstome-picker .input-group-addon {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px !important;
}

.ds-cunstome-picker .vdp-datepicker {
  width: 100%;
  height: 100%;
  align-items: center;
  vertical-align: middle;
}

.ds-cunstome-picker .vdp-datepicker * {
  height: 100%;
}

.ds-cunstome-picker .vdp-datepicker .form-control {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
}

.ds-cunstome-picker .form-control {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
}

.card__datepicker {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
  height: 45px;
  background: transparent !important;
}

.search-card__datepicker-input {
  font-weight: bold;
  color: #676666;
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
  height: 45px;
  background: transparent !important;
}
/*--------------------- Date Picker css --------------*/
</style>
